import React from 'react';
import Title from '../../atoms/title/title.js';

const Speciality = ({ type = "button", speciality, renderTitle, icon, renderIcon, title }) => {
    const kindCaseCaterpillar = speciality.iconName?.replace("_", "-") || "default";
    const specialityIcon = icon || speciality.iconUrl;
    const specialityTitle = title || speciality.name;
    let titleFontStyleDesktop;
    let titleFontStyleMobile;
    let descriptionFontStyleDesktop;
    let descriptionFontStyleMobile;
    switch (type) {
        case "standard":
            titleFontStyleDesktop = "heading-h2";
            descriptionFontStyleDesktop = "heading-h6";
            titleFontStyleMobile = "heading-h2";
            descriptionFontStyleMobile = "heading-h6";
            break;
        case "button":
            titleFontStyleDesktop = "content-small";
            titleFontStyleMobile = "caption-1";
            break;
        case "advisor-profile":
            titleFontStyleDesktop = "content-small";
            titleFontStyleMobile = speciality.iconName ? "caption-2" : "content-small";
            break;
    }
    const renderSpecialityIcon = () => (React.createElement("div", { "data-testid": "mbw-speciality-icon", className: `mbw-speciality-icon-${type}-${kindCaseCaterpillar}` }, renderIcon ? renderIcon() : React.createElement("img", { src: specialityIcon, alt: "" })));
    const renderSpecialityTitle = () => (React.createElement("div", { "data-testid": "mbw-speciality-title", className: `mbw-speciality-title-${type}` }, renderTitle ? renderTitle() : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `mbw-speciality-title-desktop-${type}` },
            React.createElement(Title, { fontStyle: titleFontStyleDesktop, bold: true }, specialityTitle)),
        React.createElement("div", { className: `mbw-speciality-title-mobile-${type}` },
            React.createElement(Title, { fontStyle: titleFontStyleMobile, bold: true }, specialityTitle))))));
    const renderSpecialityDescription = () => (React.createElement("div", { "data-testid": "mbw-speciality-description", className: `mbw-speciality-description-${type}` },
        React.createElement("div", { className: "mbw-speciality-description-desktop" },
            React.createElement(Title, { fontStyle: descriptionFontStyleDesktop }, speciality.description)),
        React.createElement("div", { className: "mbw-speciality-description-mobile" },
            React.createElement(Title, { fontStyle: descriptionFontStyleMobile }, speciality.description))));
    return (React.createElement("div", { "data-testid": "mbw-speciality", className: `mbw-speciality-${type}-${kindCaseCaterpillar}` },
        React.createElement("div", { "data-testid": "mbw-speciality-content", className: `mbw-speciality-content-${type}` },
            renderSpecialityIcon(),
            React.createElement("div", { "data-testid": "mbw-speciality-title-content", className: `mbw-speciality-title-content-${type}` },
                renderSpecialityTitle(),
                renderSpecialityDescription()))));
};

export { Speciality as default };
//# sourceMappingURL=speciality.js.map
